import { render, staticRenderFns } from "./FreeModeAlertForPopupTriggers.vue?vue&type=template&id=5ffdcefd&"
import script from "./FreeModeAlertForPopupTriggers.vue?vue&type=script&lang=ts&"
export * from "./FreeModeAlertForPopupTriggers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports